// 这边的颜色变化和校验规则，务必参考这个文档（最下面）！
// https://cooper.didichuxing.com/knowledge/2200188952729/2205822130692
import { atom } from 'jotai';

import type { FormInstance } from '@didi-pebble/pebble-design-react/es/form';
// 错误和警告提示
export const errorNoPeriodAtom = atom<Array<number>>([]); // 分时段周期未选择
export const errorNoStationDiscountAtom = atom<Array<number>>([]); // 油站未设置优惠金额
export const errorUpPriceAtom = atom<Array<number>>([]); // 油站优惠金额超出原价
export const errorLowMinimumThresholdAtom = atom<Array<number>>([]); // 油站折扣小于最低折扣
export const warningPrice50PAtom = atom<Array<number>>([]); // 油站优惠金额超过原价的50%
export const warningLowOriginStationDiscountAtom = atom<Array<number>>([]); // 油站优惠金额小于初始油站优惠金额

export const hasErrorAtom = atom<boolean>(false); // 所有错误（包含分时段周期 和 油站优惠金额错误）
export const hasWarningAtom = atom<boolean>(false); // 所有警告
export const hasStationDiscountErrorAtom = atom<boolean>(false); // 油站优惠金额错误

// 表单实例存储
export const formInstancesAtom = atom<FormInstance[]>([]);

// 设置错误提示
export const setErrorWarningAtom = atom(
  null,
  (
    _,
    set,
    payload: {
      discountInfo: any;
      minimumThresholdNum: number;
      gasStationDiscountSwitch: boolean;
    }
  ) => {
    const { discountInfo, minimumThresholdNum, gasStationDiscountSwitch } = payload;

    const errorNoPeriodList: Array<number> = []; // 分时段周期未选择
    const errorNoStationDiscountList: Array<number> = []; // 油站优惠金额未填写的列表
    const errorUpPriceList: Array<number> = []; // 油站优惠金额超出原价的列表
    const errorLowMinimumThresholdList: Array<number> = []; // 油站折扣小于最低折扣的列表
    const warningPrice50PList: Array<number> = []; // 油站优惠金额超过原价的50%的列表
    const warningLowOriginStationDiscountList: Array<number> = []; // 油站优惠金额小于初始油站优惠金额的列表

    discountInfo?.forEach(item => {
      const {
        key,
        period,
        price,
        station_discount: stationDiscount,
        origin_station_discount: originStationDiscount
      } = item;

      const priceNum = Number(price?.replace(',', '.')); // 商品原价
      const originStationDiscountNum = Number(
        `${originStationDiscount || '0,00'}`.replace(',', '.')
      ); // 油站初始优惠金额
      const stationDiscountNum = Number(`${stationDiscount || '0,00'}`.replace(',', '.')); // 油站优惠金额

      if (gasStationDiscountSwitch && (!period || !period[0] || !period[1])) {
        errorNoPeriodList.push(key); // 分时段周期未选择
      }

      if (!stationDiscount) {
        errorNoStationDiscountList.push(key); // 油站优惠金额未填写
      }

      if (stationDiscountNum >= priceNum) {
        errorUpPriceList.push(key); // 油站折扣不能超过商品原价
      }

      if (stationDiscount && stationDiscountNum < minimumThresholdNum) {
        errorLowMinimumThresholdList.push(key); // 油站折扣不能小于最低折扣
      }

      if (
        stationDiscount &&
        stationDiscountNum < priceNum &&
        stationDiscountNum > Number(priceNum) / 2
      ) {
        warningPrice50PList.push(key); // 油站优惠金额大于原价的50%
      }

      if (
        stationDiscount &&
        stationDiscountNum >= minimumThresholdNum &&
        stationDiscountNum < originStationDiscountNum
      ) {
        // 油站优惠金额小于初始优惠金额
        warningLowOriginStationDiscountList.push(key);
      }

      set(
        hasErrorAtom,
        errorNoPeriodList.length > 0 ||
          errorNoStationDiscountList.length > 0 ||
          errorUpPriceList.length > 0 ||
          errorLowMinimumThresholdList.length > 0
      ); // 是否有错误
      set(
        hasWarningAtom,
        warningPrice50PList.length > 0 || warningLowOriginStationDiscountList.length > 0
      ); // 是否有警告
      set(
        hasStationDiscountErrorAtom,
        errorNoPeriodList.length > 0 ||
          errorNoStationDiscountList.length > 0 ||
          errorUpPriceList.length > 0 ||
          errorLowMinimumThresholdList.length > 0
      ); // 油站优惠金额错误

      set(errorNoPeriodAtom, errorNoPeriodList); // 分时段周期未选择
      set(errorNoStationDiscountAtom, errorNoStationDiscountList); // 油站未设置优惠金额
      set(errorUpPriceAtom, errorUpPriceList); // 油站优惠金额超出原价
      set(errorLowMinimumThresholdAtom, errorLowMinimumThresholdList); // 油站折扣小于最低折扣
      set(warningPrice50PAtom, warningPrice50PList); // 油站优惠金额超过原价的50%
      set(warningLowOriginStationDiscountAtom, warningLowOriginStationDiscountList); // 油站优惠金额小于初始油站优惠金额
    });
  }
);
